import { render, staticRenderFns } from "./MainUser.vue?vue&type=template&id=67c64f26&"
import script from "./MainUser.vue?vue&type=script&lang=ts&"
export * from "./MainUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports